<template>
  <div class="flex flex-row justify-between w-full">
    <div class="flex items-center gap-3">
      <woot-thumbnail
        :src="sender.thumbnail"
        size="32px"
        :username="sender.name"
        :status="sender.availability_status"
      />
      <div class="flex items-center gap-2">
        <email-tooltip :sections="senderSections">
          <span
            class="text-sm font-semibold text-gray-800"
            :class="isIncoming ? 'cursor-pointer' : 'cursor-default'"
            @click.stop="onToggleContactPanel('incoming')"
          >
            {{ sender.name }}
          </span>
        </email-tooltip>
        <span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="{ '-scale-x-[100%]': isRTLView }"
          >
            <path
              d="M9.88791 3.55172L9.17507 4.24788L12.4277 7.50055L1.66357 7.50055L1.66357 8.50039L12.4341 8.50039L9.19174 11.7531L9.88791 12.4492L14.3366 8.00039L9.88791 3.55172Z"
              fill="#6B7280"
              style="
                fill: #6b7280;
                fill: color(display-p3 0.4196 0.4471 0.502);
                fill-opacity: 1;
              "
            />
          </svg>
        </span>
        <email-tooltip :sections="receiverDetailTooltip">
          <span
            class="text-sm font-semibold text-gray-800"
            :class="isIncoming ? 'cursor-default' : 'cursor-pointer'"
            @click.stop="onToggleContactPanel('outgoing')"
          >
            {{ receiverName }}
          </span>
        </email-tooltip>
      </div>
    </div>
    <div class="flex items-center">
      <div class="flex items-center gap-2">
        <slot name="custom-tag" />
        <span
          v-if="hasPrivateNote"
          v-tooltip.top="$t('CONVERSATION.REPLYBOX.PRIVATE_NOTE')"
          class="material-symbols-outlined text-base/[16px] text-[#F59E0B]"
        >
          draft
        </span>
        <span class="text-sm text-gray-500">
          {{ relativeDate }}
          {{ hourStamp }}
        </span>
        <fluent-icon
          v-if="delayHours"
          v-tooltip.top="
            $t('CONVERSATION.REPLYBOX.SENDING_BY', { date: scheduledDate })
          "
          icon="ion-clock"
          class="scheduled-clock"
        />
      </div>
      <slot name="contextMenu" />
    </div>
  </div>
</template>

<script>
import EmailTooltip from './EmailTooltip.vue';
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  components: { EmailTooltip },
  mixins: [rtlMixin],
  inject: ['toggleContactPanel', 'latestIncomingMessageId'],
  props: {
    sender: {
      type: Object,
      required: true,
    },
    receiverDetailTooltip: {
      type: Array,
      default: () => [],
    },
    receiverName: {
      type: String,
      default: '',
    },
    hasPrivateNote: {
      type: Boolean,
      default: false,
    },
    relativeDate: {
      type: String,
      default: '',
    },
    hourStamp: {
      type: String,
      default: '',
    },
    // d99d - scheduled (delayed) message indicator, same as the WhatsApp bubble
    delayHours: {
      type: Number,
      default: null,
    },
    scheduledDate: {
      type: String,
      default: '',
    },
    messageId: {
      type: Number,
      default: 0,
    },
    variant: {
      type: String,
      default: 'incoming',
      validator: v => ['incoming', 'outgoing'].includes(v),
    },
  },
  computed: {
    senderSections() {
      return this.sender?.email
        ? [
            {
              label: this.$t('EMAIL_HEADER.FROM'),
              emails: Array.isArray(this.sender.email)
                ? this.sender.email
                : [this.sender.email],
            },
          ]
        : [];
    },
    isIncoming() {
      return this.variant === 'incoming';
    },
  },
  methods: {
    onToggleContactPanel(mode) {
      if (this.variant === mode) this.toggleContactPanel();
    },
  },
};
</script>

<style lang="scss" scoped>
// d99d - matches the clock shown on scheduled WhatsApp bubbles (bubble/Actions.vue)
.scheduled-clock {
  color: #ef4444 !important;
  font-size: 18px !important;
  @apply flex items-center;
}
</style>
